<template>
    <div class="coupon-list-component">
        <ul v-if="list && list.length > 0">
            <li
              class="tab-panel-li panel-item-li global_pointer"
              v-for="(item, index) in list"
              :key="item.id"
              @click="couponClick(index, item)"
            >
                <CouponItem :item="item" v-bind="$attrs"/>
            </li>
        </ul>
        <img v-else src="@/assets/imgs/order/default_promos.png" alt="" />
    </div>
</template>
<script>
import api from "@/api/api_list.js";
import CouponItem from './coupon-item.vue';
export default {
    components: {
        CouponItem
    },
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
        }
    },
    methods: {
        async couponClick(index, row) {
            if (this.$attrs.tabName === 'cannotUse') return
            try {
                console.log('this.$attrs.goodList', this.$attrs.goodList)
                const merchandiseList = this.$attrs.skus.map((item, index) => {
                    item.num = item.buyNum = this.$attrs.goodList[index].buyNum
                    return item;
                });
                const data = { userTicketId: row.id, merchandiseList, orderAddrId: this.$attrs.addrId};
                let emitParams = {
                    userTicketId: row.id,
                }
                if (this.$attrs.bestTicketInfo && this.$attrs.bestTicketInfo.id === row.id) {
                    delete data.userTicketId
                    emitParams.userTicketId = ''
                }
                const { code, result, msg } = await api.set_ticket(data);
                if(!code){
                    // this.$store.dispatch('pay_get_coupon', row);
                    emitParams.discountInfo = { ...result }
                    this.$emit('discountInfo', emitParams);
                }
                else{
                    this.$toast(msg)
                }
            } catch (error) {
                console.log(error);
            }
        },
    }
}
</script>
<style lang="less" scoped>
.coupon-list-component {
  position: absolute;
  background: #f4f7f7;
  width: 100%;
  top: 44px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 100px;
  img {
    width: 168px;
    height: 168px;
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>